import { useMutation, useQuery } from '@tanstack/react-query';
import { IAppSetting } from '../../Interfaces/IAppSetting';
import { customFetcher } from '../useFetch';
import { IApp } from '../../Interfaces/IApp';
import { IExtension } from '../../Interfaces/IExtension';

export const useGetAppArray = () => {
  const {
    data: appArray,
    isLoading: isLoadingAppArray,
    refetch: refetchAppArray,
  } = useQuery<IApp[]>({
    queryKey: ['app'],
    queryFn: () => customFetcher({ endpoint: '/app' }),
  });

  return { appArray, isLoadingAppArray, refetchAppArray };
};

export const useGetSettingAppArray = () => {
  const {
    data: appSettingArray,
    isLoading: isLoadingAppSettingArray,
    refetch: refetchAppSettingArray,
  } = useQuery<IAppSetting[]>({
    queryKey: ['appsetting'],
    queryFn: () => customFetcher({ endpoint: '/appsetting' }),
  });

  return { appSettingArray, isLoadingAppSettingArray, refetchAppSettingArray };
};

export const useBulkUploadAppSetting = () => {
  const {
    mutateAsync: bulkUplaodAppSetting,
    isPending: isPendingBulkUploadAppSetting,
  } = useMutation({
    mutationFn: (appSetting: IAppSetting[]) =>
      customFetcher({
        endpoint: '/appsetting/bulk_upload',
        method: 'POST',
        body: appSetting,
      }),
  });
  return {
    bulkUplaodAppSetting,
    isPendingBulkUploadAppSetting,
  };
};

export const useGetExtensions = () => {
  const {
    data: extensionArray,
    isLoading: isLoadingExtensionArray,
    refetch: refetchExtensionArray,
  } = useQuery<IExtension[]>({
    queryKey: ['app/marketplace'],
    queryFn: () => customFetcher({ endpoint: '/app/marketplace' }),
  });

  return { extensionArray, isLoadingExtensionArray, refetchExtensionArray };
};
